import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m13.7 12-2.95 1.7v-3.4z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4 20.41c1.59.52 7.35.52 8 .52s6.42-.01 8-.52a3.5 3.5 0 0 0 2.31-2.62c.309-1.914.456-3.851.44-5.79a34.6 34.6 0 0 0-.48-5.79A3.47 3.47 0 0 0 20 3.59c-1.58-.52-7.39-.52-8-.52s-6.37.01-8 .52a3.5 3.5 0 0 0-2.31 2.62A34.7 34.7 0 0 0 1.25 12a34.7 34.7 0 0 0 .48 5.79A3.47 3.47 0 0 0 4 20.41m5.63-4.76c.111.068.24.102.37.1a.75.75 0 0 0 .38-.1l5.19-3a.75.75 0 0 0 0-1.3l-5.19-3a.77.77 0 0 0-1.03.272.73.73 0 0 0-.1.378v6a.73.73 0 0 0 .38.65",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }